import { DEFAULT_ACTION_SOURCE } from '../utils/constants';
import getConversationId from '../utils/getConversationId';
import { closeDeeplinkReadingPane } from 'owa-mail-actions/lib/readingPaneActions';
import { tryGetNewFocusedNodeOnDelete } from 'owa-mail-reading-pane-store/lib/actions/focusNextPrevItemPart';
import setFocusedItemPart from 'owa-mail-reading-pane-store/lib/actions/setFocusedItemPart';
import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import getDefaultDisposalType from 'owa-mail-reading-pane-store/lib/utils/getDefaultDisposalType';
import { ClientItem } from 'owa-mail-store';
import { InstrumentationContext } from 'owa-mail-store';
import { lazyDeleteItems } from 'owa-mail-triage-action';
import * as React from 'react';

export default function onDelete(
    viewState: ItemViewState,
    item: ClientItem,
    instrumentationContext: InstrumentationContext
) {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        const conversationId = getConversationId(viewState, item);
        if (conversationId) {
            const newFocusedNode = tryGetNewFocusedNodeOnDelete(
                conversationId,
                viewState as ItemPartViewState
            );
            lazyDeleteItems
                .importAndExecute(
                    [item.ItemId.Id],
                    getDefaultDisposalType(item.ItemId.Id),
                    [instrumentationContext],
                    DEFAULT_ACTION_SOURCE,
                    item.MailboxInfo,
                    true /* disableResetFocus */
                )
                .then(() => {
                    // set focusedItemPart in the callback is to make sure itemPartDiv.focus() scroll to the correct position
                    setFocusedItemPart(newFocusedNode, conversationId);
                });
        } else {
            lazyDeleteItems
                .importAndExecute(
                    [item.ItemId.Id],
                    getDefaultDisposalType(item.ItemId.Id),
                    [instrumentationContext],
                    DEFAULT_ACTION_SOURCE,
                    item.MailboxInfo
                )
                .then(() => {
                    closeDeeplinkReadingPane();
                });
        }
    };
}
